var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLessThan = function SvgLessThan(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26799_152925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3125 3.41095V2.20313C11.3125 2.09845 11.1922 2.04063 11.111 2.1047L4.06721 7.60626C4.00736 7.6528 3.95894 7.7124 3.92563 7.7805C3.89232 7.8486 3.875 7.92341 3.875 7.99923C3.875 8.07504 3.89232 8.14985 3.92563 8.21796C3.95894 8.28606 4.00736 8.34565 4.06721 8.3922L11.111 13.8938C11.1938 13.9578 11.3125 13.9 11.3125 13.7953V12.5875C11.3125 12.5109 11.2766 12.4375 11.2172 12.3906L5.59221 8.00001L11.2172 3.60782C11.2766 3.56095 11.3125 3.48751 11.3125 3.41095Z",
    fill: "#626262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26799_152925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLessThan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/less-than.0f23cf2e.svg";
export { ForwardRef as ReactComponent };